module.exports = __webpack_public_path__ + "img/p-one-step-07.aa1bc344.png";